const stores = require.context('./store', false, /\.js$/)
const modules = {}
stores.keys().forEach(key => {
  if (key === './index.js') return
  const moduleName = key.replace(/(\.\/|\.js)/g, '')
  modules[moduleName] = stores(key).default
})
export { modules }
